import { defineStore } from "pinia";
import { ResponseGroup } from "../responses";
import { Ref, ref } from "vue";
import { PublishedSurveyPageType, PublishedSurveyQuestionType, ResponseGroupType } from "@/common/interfaces";

export const useResponseStore = defineStore('responseStore', () => {
	const responseGroup: Ref<ResponseGroup | null> = ref(null);

	const seenQuestions: Ref<Array<PublishedSurveyQuestionType>> = ref([]);

	const loaded: Ref<boolean> = ref(false);

	function clearStore() {
		responseGroup.value = null;
		loaded.value = false;
	}

	function setFromRemote(remoteResponseGroup: ResponseGroupType) {
		responseGroup.value = ResponseGroup.fromRemote(remoteResponseGroup);
	}

	function updateFromRemote(remoteResponseGroup: ResponseGroupType) {
		if (responseGroup.value === null) {
			return;
		}

		responseGroup.value.updateFromRemote(remoteResponseGroup);
	}

	function addSeenPage(page: PublishedSurveyPageType): void {
		for (const question of page.questions) {
			const existingIndex = seenQuestions.value.findIndex(
				(pq: PublishedSurveyQuestionType) => pq.uuid === question.uuid
			);

			if (existingIndex === -1) {
				seenQuestions.value.push(question);
			}
		}
	}

	function getSeenQuestion(questionUuid: string): PublishedSurveyQuestionType | null {
		const existing = seenQuestions.value.find(
			(pq: PublishedSurveyQuestionType) => pq.uuid === questionUuid
		);

		return (existing)? existing : null;
	}

	return {
		clearStore,
		setFromRemote, updateFromRemote,
		responseGroup, loaded,
		seenQuestions, addSeenPage, getSeenQuestion
	};
});
